import {
  StringSerializer_getInstance2wffkbpdux3h9 as StringSerializer_getInstance,
  IntSerializer_getInstance2q7s8kvk1il5u as IntSerializer_getInstance,
  BooleanSerializer_getInstance1t8habeqgiyq1 as BooleanSerializer_getInstance,
  ByteSerializer_getInstance2o4jevxladj6p as ByteSerializer_getInstance,
  ShortSerializer_getInstance330bccrmjn2n6 as ShortSerializer_getInstance,
  LongSerializer_getInstance194e4t3ow5wjs as LongSerializer_getInstance,
  FloatSerializer_getInstance2fspe61zbqree as FloatSerializer_getInstance,
  DoubleSerializer_getInstance3da4hv5ndgjlx as DoubleSerializer_getInstance,
  CharSerializer_getInstance368f23bfe318s as CharSerializer_getInstance,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  LinkedHashMapSerializermaoj2nyji7op as LinkedHashMapSerializer,
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getBigIntHashCode294hi5bdhtj6e as getBigIntHashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  removePrefix279df90bhrqqg as removePrefix,
  substringBeforekje8w2lxhyb6 as substringBefore,
} from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { endsWith3cq61xxngobwh as endsWith } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { KSerializerWithDefault194z2ragoko00 as KSerializerWithDefault } from './Defaults.mjs';
import { ENUM_getInstance22lfbrqor0c0a as ENUM_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  get_isNullable36pbikm8xb7bz as get_isNullable,
  get_isInline5x26qrhi9qs6 as get_isInline,
  get_annotationshjxdbdcl8kmv as get_annotations,
  SerialDescriptor2pelqekb5ic3a as SerialDescriptor,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptor.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { ObjectSerializer2kjkucmygguwd as ObjectSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/ObjectSerializer.mjs';
import {
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
  toString3o7ifthqydp6e as toString_0,
  Char__hashCode_impl_otmys1oweesmrnpzd6 as Char__hashCode_impl_otmys,
  Char19o2r8palgjof as Char,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { SealedClassSerializeriwipiibk55zc as SealedClassSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SealedSerializer.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
import {
  isArray1hxjqtqy632bc as isArray,
  isCharArray21auq5hbrg68m as isCharArray,
  isDoubleArray1wyh4nyf7pjxn as isDoubleArray,
  isFloatArrayjjscnqphw92j as isFloatArray,
  isLongArray2fdt3z7yu3ef as isLongArray,
  isIntArrayeijsubfngq38 as isIntArray,
  isShortArraywz30zxwtqi8h as isShortArray,
  isByteArray4nnzfn1x4o3w as isByteArray,
  isBooleanArray35llghle4c6w1 as isBooleanArray,
  isInterface3d6p8outrmvmk as isInterface,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { serializerOrNull294cbc318ws50 as serializerOrNull } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import { KClass1cc9rfeybg8hs as KClass } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KClassJs.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var skipTypes;
function SerializableAnnotation$Companion$$childSerializers$_anonymous__haf4po() {
  return new (LinkedHashMapSerializer())(StringSerializer_getInstance(), Companion_getInstance_18().m2a());
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.a3j_1 = [null, lazy(tmp_0, SerializableAnnotation$Companion$$childSerializers$_anonymous__haf4po)];
        this.b3j_1 = HashMap().n8();
      }
      c3j(name, handler) {
        var tmp0 = this.b3j_1;
        // Inline function 'kotlin.collections.set' call
        var value = typeof handler === 'function' ? handler : THROW_CCE();
        tmp0.s3(name, value);
      }
      q4r(annotation) {
        var fqn = substringBefore(removePrefix(toString(annotation), '@'), '(');
        var tmp0_safe_receiver = this.b3j_1.p3(fqn);
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver(annotation);
      }
      m2a() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.serialization.SerializableAnnotation', this, 2);
        tmp0_serialDesc.c1b('fqn', false);
        tmp0_serialDesc.c1b('values', false);
        this.j4s_1 = tmp0_serialDesc;
      }
      k4s(encoder, value) {
        var tmp0_desc = this.j4s_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance().a3j_1;
        tmp1_output.a15(tmp0_desc, 0, value.l4s_1);
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.m4s_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.k4s(encoder, value instanceof SerializableAnnotation() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.j4s_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        var tmp7_cached = Companion_getInstance().a3j_1;
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, tmp7_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, tmp7_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return SerializableAnnotation().n4s(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.j4s_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance().a3j_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), tmp0_cached[1].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var SerializableAnnotationClass;
function SerializableAnnotation() {
  if (SerializableAnnotationClass === VOID) {
    class $ {
      constructor(fqn, values) {
        Companion_getInstance();
        this.l4s_1 = fqn;
        this.m4s_1 = values;
      }
      toString() {
        return 'SerializableAnnotation(fqn=' + this.l4s_1 + ', values=' + toString(this.m4s_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.l4s_1);
        result = imul(result, 31) + hashCode(this.m4s_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SerializableAnnotation()))
          return false;
        if (!(this.l4s_1 === other.l4s_1))
          return false;
        if (!equals(this.m4s_1, other.m4s_1))
          return false;
        return true;
      }
      static n4s(seen0, fqn, values, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance().j4s_1);
        }
        var $this = createThis(this);
        $this.l4s_1 = fqn;
        $this.m4s_1 = values;
        return $this;
      }
    }
    initMetadataForClass($, 'SerializableAnnotation', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    SerializableAnnotationClass = $;
  }
  return SerializableAnnotationClass;
}
function VirtualField$Companion$$childSerializers$_anonymous__4z6o3p() {
  return new (ArrayListSerializer())($serializer_getInstance());
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.t3k_1 = [null, null, null, null, lazy(tmp_0, VirtualField$Companion$$childSerializers$_anonymous__4z6o3p), null, null];
      }
      m2a() {
        return $serializer_getInstance_0();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.serialization.VirtualField', this, 7);
        tmp0_serialDesc.c1b('index', false);
        tmp0_serialDesc.c1b('name', false);
        tmp0_serialDesc.c1b('type', false);
        tmp0_serialDesc.c1b('optional', false);
        tmp0_serialDesc.c1b('annotations', false);
        tmp0_serialDesc.c1b('defaultJson', true);
        tmp0_serialDesc.c1b('defaultCode', true);
        this.o4s_1 = tmp0_serialDesc;
      }
      p4s(encoder, value) {
        var tmp0_desc = this.o4s_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_0().t3k_1;
        tmp1_output.v14(tmp0_desc, 0, value.q4s_1);
        tmp1_output.a15(tmp0_desc, 1, value.r4s_1);
        tmp1_output.c15(tmp0_desc, 2, $serializer_getInstance_1(), value.s4s_1);
        tmp1_output.s14(tmp0_desc, 3, value.t4s_1);
        tmp1_output.c15(tmp0_desc, 4, tmp2_cached[4].f2(), value.u4s_1);
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !(value.v4s_1 == null)) {
          tmp1_output.d15(tmp0_desc, 5, StringSerializer_getInstance(), value.v4s_1);
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !(value.w4s_1 == null)) {
          tmp1_output.d15(tmp0_desc, 6, StringSerializer_getInstance(), value.w4s_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.p4s(encoder, value instanceof VirtualField() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.o4s_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = 0;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = false;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_input = decoder.l13(tmp0_desc);
        var tmp12_cached = Companion_getInstance_0().t3k_1;
        if (tmp11_input.a14()) {
          tmp4_local0 = tmp11_input.q13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp11_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp11_input.x13(tmp0_desc, 2, $serializer_getInstance_1(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp11_input.n13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp11_input.x13(tmp0_desc, 4, tmp12_cached[4].f2(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp11_input.z13(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp11_input.z13(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp11_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp11_input.q13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp11_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp11_input.x13(tmp0_desc, 2, $serializer_getInstance_1(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp11_input.n13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp11_input.x13(tmp0_desc, 4, tmp12_cached[4].f2(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp11_input.z13(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp11_input.z13(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp11_input.m13(tmp0_desc);
        return VirtualField().x4s(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
      }
      az() {
        return this.o4s_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_0().t3k_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [IntSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_1(), BooleanSerializer_getInstance(), tmp0_cached[4].f2(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
var VirtualFieldClass;
function VirtualField() {
  if (VirtualFieldClass === VOID) {
    class $ {
      toString() {
        return this.r4s_1 + ': ' + this.s4s_1.toString();
      }
      hashCode() {
        var result = this.q4s_1;
        result = imul(result, 31) + getStringHashCode(this.r4s_1) | 0;
        result = imul(result, 31) + this.s4s_1.hashCode() | 0;
        result = imul(result, 31) + getBooleanHashCode(this.t4s_1) | 0;
        result = imul(result, 31) + hashCode(this.u4s_1) | 0;
        result = imul(result, 31) + (this.v4s_1 == null ? 0 : getStringHashCode(this.v4s_1)) | 0;
        result = imul(result, 31) + (this.w4s_1 == null ? 0 : getStringHashCode(this.w4s_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof VirtualField()))
          return false;
        if (!(this.q4s_1 === other.q4s_1))
          return false;
        if (!(this.r4s_1 === other.r4s_1))
          return false;
        if (!this.s4s_1.equals(other.s4s_1))
          return false;
        if (!(this.t4s_1 === other.t4s_1))
          return false;
        if (!equals(this.u4s_1, other.u4s_1))
          return false;
        if (!(this.v4s_1 == other.v4s_1))
          return false;
        if (!(this.w4s_1 == other.w4s_1))
          return false;
        return true;
      }
      static x4s(seen0, index, name, type, optional, annotations, defaultJson, defaultCode, serializationConstructorMarker) {
        Companion_getInstance_0();
        if (!(31 === (31 & seen0))) {
          throwMissingFieldException(seen0, 31, $serializer_getInstance_0().o4s_1);
        }
        var $this = createThis(this);
        $this.q4s_1 = index;
        $this.r4s_1 = name;
        $this.s4s_1 = type;
        $this.t4s_1 = optional;
        $this.u4s_1 = annotations;
        if (0 === (seen0 & 32))
          $this.v4s_1 = null;
        else
          $this.v4s_1 = defaultJson;
        if (0 === (seen0 & 64))
          $this.w4s_1 = null;
        else
          $this.w4s_1 = defaultCode;
        return $this;
      }
    }
    initMetadataForClass($, 'VirtualField', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
    VirtualFieldClass = $;
  }
  return VirtualFieldClass;
}
function VirtualTypeReference$Companion$$childSerializers$_anonymous__lthuf8() {
  return new (ArrayListSerializer())($serializer_getInstance_1());
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.u3k_1 = [null, lazy(tmp_0, VirtualTypeReference$Companion$$childSerializers$_anonymous__lthuf8), null];
      }
      m2a() {
        return $serializer_getInstance_1();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  if (Companion_instance_1 === VOID)
    new (Companion_1())();
  return Companion_instance_1;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.serialization.VirtualTypeReference', this, 3);
        tmp0_serialDesc.c1b('serialName', false);
        tmp0_serialDesc.c1b('arguments', false);
        tmp0_serialDesc.c1b('isNullable', false);
        this.y4s_1 = tmp0_serialDesc;
      }
      z4s(encoder, value) {
        var tmp0_desc = this.y4s_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_1().u3k_1;
        tmp1_output.a15(tmp0_desc, 0, value.a4t_1);
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.b4t_1);
        tmp1_output.s14(tmp0_desc, 2, value.c4t_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.z4s(encoder, value instanceof VirtualTypeReference() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.y4s_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = false;
        var tmp7_input = decoder.l13(tmp0_desc);
        var tmp8_cached = Companion_getInstance_1().u3k_1;
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.x13(tmp0_desc, 1, tmp8_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.n13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.x13(tmp0_desc, 1, tmp8_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.n13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return VirtualTypeReference().d4t(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.y4s_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_1().u3k_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), tmp0_cached[1].f2(), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
function VirtualTypeReference$toString$lambda(it) {
  return it.toString();
}
var VirtualTypeReferenceClass;
function VirtualTypeReference() {
  if (VirtualTypeReferenceClass === VOID) {
    class $ {
      toString() {
        // Inline function 'kotlin.takeUnless' call
        var this_0 = this.b4t_1;
        var tmp;
        if (!this_0.i1()) {
          tmp = this_0;
        } else {
          tmp = null;
        }
        var tmp0_safe_receiver = tmp;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          tmp_0 = joinToString(tmp0_safe_receiver, ', ', '<', '>', VOID, VOID, VirtualTypeReference$toString$lambda);
        }
        var tmp1_elvis_lhs = tmp_0;
        return this.a4t_1 + (tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs) + (this.c4t_1 ? '?' : '');
      }
      hashCode() {
        var result = getStringHashCode(this.a4t_1);
        result = imul(result, 31) + hashCode(this.b4t_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.c4t_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof VirtualTypeReference()))
          return false;
        if (!(this.a4t_1 === other.a4t_1))
          return false;
        if (!equals(this.b4t_1, other.b4t_1))
          return false;
        if (!(this.c4t_1 === other.c4t_1))
          return false;
        return true;
      }
      static d4t(seen0, serialName, arguments_0, isNullable, serializationConstructorMarker) {
        Companion_getInstance_1();
        if (!(7 === (7 & seen0))) {
          throwMissingFieldException(seen0, 7, $serializer_getInstance_1().y4s_1);
        }
        var $this = createThis(this);
        $this.a4t_1 = serialName;
        $this.b4t_1 = arguments_0;
        $this.c4t_1 = isNullable;
        if (endsWith($this.a4t_1, '?'))
          throw Exception().td();
        return $this;
      }
    }
    initMetadataForClass($, 'VirtualTypeReference', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
    VirtualTypeReferenceClass = $;
  }
  return VirtualTypeReferenceClass;
}
function VirtualStruct$Concrete$_get_serializableProperties_$ref_24cqpv() {
  return (p0) => p0.t4r();
}
function VirtualStruct$Companion$$childSerializers$_anonymous__6newk6() {
  return new (ArrayListSerializer())($serializer_getInstance());
}
function VirtualStruct$Companion$$childSerializers$_anonymous__6newk6_0() {
  return new (ArrayListSerializer())($serializer_getInstance_0());
}
function VirtualStruct$Companion$$childSerializers$_anonymous__6newk6_1() {
  return new (ArrayListSerializer())($serializer_getInstance_4());
}
var ConcreteClass;
function Concrete() {
  if (ConcreteClass === VOID) {
    class $ {
      t4r() {
        var tmp0 = this.s4r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializableProperties', 1, tmp, VirtualStruct$Concrete$_get_serializableProperties_$ref_24cqpv(), null);
        return tmp0.f2();
      }
    }
    initMetadataForClass($, 'Concrete', VOID, VOID, [KSerializer(), VirtualType(), KSerializerWithDefault()]);
    ConcreteClass = $;
  }
  return ConcreteClass;
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      constructor() {
        Companion_instance_2 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, VirtualStruct$Companion$$childSerializers$_anonymous__6newk6);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, VirtualStruct$Companion$$childSerializers$_anonymous__6newk6_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.p3k_1 = [null, tmp_1, tmp_3, lazy(tmp_4, VirtualStruct$Companion$$childSerializers$_anonymous__6newk6_1), null];
      }
      m2a() {
        return $serializer_getInstance_2();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  if (Companion_instance_2 === VOID)
    new (Companion_2())();
  return Companion_instance_2;
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_2 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.serialization.VirtualStruct', this, 5);
        tmp0_serialDesc.c1b('serialName', false);
        tmp0_serialDesc.c1b('annotations', false);
        tmp0_serialDesc.c1b('fields', false);
        tmp0_serialDesc.c1b('parameters', false);
        tmp0_serialDesc.c1b('idField', true);
        this.e4t_1 = tmp0_serialDesc;
      }
      f4t(encoder, value) {
        var tmp0_desc = this.e4t_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_2().p3k_1;
        tmp1_output.a15(tmp0_desc, 0, value.g4t_1);
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.h4t_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.i4t_1);
        tmp1_output.c15(tmp0_desc, 3, tmp2_cached[3].f2(), value.j4t_1);
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 4)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.find' call
          var tmp0 = value.i4t_1;
          var tmp$ret$1;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if (element.r4s_1 === '_id') {
                tmp$ret$1 = element;
                break $l$block;
              }
            }
            tmp$ret$1 = null;
          }
          var tmp$ret$2 = tmp$ret$1;
          tmp = !equals(value.k4t_1, tmp$ret$2);
        }
        if (tmp) {
          tmp1_output.d15(tmp0_desc, 4, $serializer_getInstance_0(), value.k4t_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.f4t(encoder, value instanceof VirtualStruct() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.e4t_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_input = decoder.l13(tmp0_desc);
        var tmp10_cached = Companion_getInstance_2().p3k_1;
        if (tmp9_input.a14()) {
          tmp4_local0 = tmp9_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp9_input.x13(tmp0_desc, 1, tmp10_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp9_input.x13(tmp0_desc, 2, tmp10_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp9_input.x13(tmp0_desc, 3, tmp10_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp9_input.z13(tmp0_desc, 4, $serializer_getInstance_0(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp9_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp9_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp9_input.x13(tmp0_desc, 1, tmp10_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp9_input.x13(tmp0_desc, 2, tmp10_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp9_input.x13(tmp0_desc, 3, tmp10_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp9_input.z13(tmp0_desc, 4, $serializer_getInstance_0(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp9_input.m13(tmp0_desc);
        return VirtualStruct().l4t(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
      }
      az() {
        return this.e4t_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_2().p3k_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), tmp0_cached[1].f2(), tmp0_cached[2].f2(), tmp0_cached[3].f2(), get_nullable($serializer_getInstance_0())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var $serializer_instance_2;
function $serializer_getInstance_2() {
  if ($serializer_instance_2 === VOID)
    new ($serializer_2())();
  return $serializer_instance_2;
}
function VirtualStruct$toString$lambda(it) {
  return it.m4t_1;
}
var VirtualStructClass;
function VirtualStruct() {
  if (VirtualStructClass === VOID) {
    class $ {
      bz() {
        return this.h4t_1;
      }
      toString() {
        // Inline function 'kotlin.takeUnless' call
        var this_0 = this.j4t_1;
        var tmp;
        if (!this_0.i1()) {
          tmp = this_0;
        } else {
          tmp = null;
        }
        var tmp0_safe_receiver = tmp;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          tmp_0 = joinToString(tmp0_safe_receiver, ', ', '<', '>', VOID, VOID, VirtualStruct$toString$lambda);
        }
        var tmp1_elvis_lhs = tmp_0;
        return 'virtual data class ' + this.g4t_1 + (tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs) + '(' + joinToString(this.i4t_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.g4t_1);
        result = imul(result, 31) + hashCode(this.h4t_1) | 0;
        result = imul(result, 31) + hashCode(this.i4t_1) | 0;
        result = imul(result, 31) + hashCode(this.j4t_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof VirtualStruct()))
          return false;
        if (!(this.g4t_1 === other.g4t_1))
          return false;
        if (!equals(this.h4t_1, other.h4t_1))
          return false;
        if (!equals(this.i4t_1, other.i4t_1))
          return false;
        if (!equals(this.j4t_1, other.j4t_1))
          return false;
        return true;
      }
      static l4t(seen0, serialName, annotations, fields, parameters, idField, serializationConstructorMarker) {
        Companion_getInstance_2();
        if (!(15 === (15 & seen0))) {
          throwMissingFieldException(seen0, 15, $serializer_getInstance_2().e4t_1);
        }
        var $this = createThis(this);
        $this.g4t_1 = serialName;
        $this.h4t_1 = annotations;
        $this.i4t_1 = fields;
        $this.j4t_1 = parameters;
        if (0 === (seen0 & 16)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.find' call
          var tmp0 = $this.i4t_1;
          var tmp$ret$1;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if (element.r4s_1 === '_id') {
                tmp$ret$1 = element;
                break $l$block;
              }
            }
            tmp$ret$1 = null;
          }
          tmp.k4t_1 = tmp$ret$1;
        } else
          $this.k4t_1 = idField;
        return $this;
      }
    }
    initMetadataForClass($, 'VirtualStruct', VOID, VOID, [VirtualType()], VOID, VOID, {0: $serializer_getInstance_2});
    VirtualStructClass = $;
  }
  return VirtualStructClass;
}
var VirtualTypeClass;
function VirtualType() {
  if (VirtualTypeClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'VirtualType');
    VirtualTypeClass = $;
  }
  return VirtualTypeClass;
}
function VirtualEnum$Companion$$childSerializers$_anonymous__3gjyda() {
  return new (ArrayListSerializer())($serializer_getInstance());
}
function VirtualEnum$Companion$$childSerializers$_anonymous__3gjyda_0() {
  return new (ArrayListSerializer())($serializer_getInstance_6());
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      constructor() {
        Companion_instance_3 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, VirtualEnum$Companion$$childSerializers$_anonymous__3gjyda);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.q3k_1 = [null, tmp_1, lazy(tmp_2, VirtualEnum$Companion$$childSerializers$_anonymous__3gjyda_0)];
        this.r3k_1 = HashMap().n8();
      }
      m2a() {
        return $serializer_getInstance_3();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  if (Companion_instance_3 === VOID)
    new (Companion_3())();
  return Companion_instance_3;
}
var $serializerClass_3;
function $serializer_3() {
  if ($serializerClass_3 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_3 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.serialization.VirtualEnum', this, 3);
        tmp0_serialDesc.c1b('serialName', false);
        tmp0_serialDesc.c1b('annotations', false);
        tmp0_serialDesc.c1b('options', false);
        this.n4t_1 = tmp0_serialDesc;
      }
      o4t(encoder, value) {
        var tmp0_desc = this.n4t_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_3().q3k_1;
        tmp1_output.a15(tmp0_desc, 0, value.p4t_1);
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.q4t_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.r4t_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.o4t(encoder, value instanceof VirtualEnum() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.n4t_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp10_input = decoder.l13(tmp0_desc);
        var tmp11_cached = Companion_getInstance_3().q3k_1;
        if (tmp10_input.a14()) {
          tmp4_local0 = tmp10_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp10_input.x13(tmp0_desc, 1, tmp11_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp10_input.x13(tmp0_desc, 2, tmp11_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp10_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp10_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp10_input.x13(tmp0_desc, 1, tmp11_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp10_input.x13(tmp0_desc, 2, tmp11_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp10_input.m13(tmp0_desc);
        return VirtualEnum().v4t(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.n4t_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_3().q3k_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), tmp0_cached[1].f2(), tmp0_cached[2].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_3 = $;
  }
  return $serializerClass_3;
}
var $serializer_instance_3;
function $serializer_getInstance_3() {
  if ($serializer_instance_3 === VOID)
    new ($serializer_3())();
  return $serializer_instance_3;
}
var VirtualEnum$1Class;
function VirtualEnum$1() {
  if (VirtualEnum$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.y4t_1 = this$0;
        this.w4t_1 = ENUM_getInstance();
        this.x4t_1 = this$0.p4t_1;
      }
      u11() {
        return this.y4t_1.r4t_1.p1();
      }
      s11() {
        return this.w4t_1;
      }
      h10() {
        return this.x4t_1;
      }
      x11(index) {
        // Inline function 'kotlin.collections.listOf' call
        return emptyList();
      }
      y11(index) {
        return this;
      }
      w11(name) {
        var tmp0_safe_receiver = this.y4t_1.t4t_1.p3(name);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b4u_1;
        return tmp1_elvis_lhs == null ? -3 : tmp1_elvis_lhs;
      }
      v11(index) {
        return this.y4t_1.r4t_1.q1(index).z4t_1;
      }
      z11(index) {
        return false;
      }
    }
    protoOf($).l11 = get_isNullable;
    protoOf($).t11 = get_isInline;
    protoOf($).bz = get_annotations;
    initMetadataForClass($, VOID, VOID, VOID, [SerialDescriptor()]);
    VirtualEnum$1Class = $;
  }
  return VirtualEnum$1Class;
}
var VirtualEnumClass;
function VirtualEnum() {
  if (VirtualEnumClass === VOID) {
    class $ {
      bz() {
        return this.q4t_1;
      }
      toString() {
        return 'Virtual ' + this.p4t_1 + ' { ' + joinToString(this.r4t_1) + ' }';
      }
      az() {
        return this.u4t_1;
      }
      pz(decoder) {
        return this.s4t_1.q1(decoder.i13(this.u4t_1));
      }
      c4u(encoder, value) {
        encoder.q14(this.u4t_1, value.e4u_1);
      }
      oz(encoder, value) {
        return this.c4u(encoder, value instanceof VirtualEnumValue() ? value : THROW_CCE());
      }
      hashCode() {
        var result = getStringHashCode(this.p4t_1);
        result = imul(result, 31) + hashCode(this.q4t_1) | 0;
        result = imul(result, 31) + hashCode(this.r4t_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof VirtualEnum()))
          return false;
        if (!(this.p4t_1 === other.p4t_1))
          return false;
        if (!equals(this.q4t_1, other.q4t_1))
          return false;
        if (!equals(this.r4t_1, other.r4t_1))
          return false;
        return true;
      }
      static v4t(seen0, serialName, annotations, options, serializationConstructorMarker) {
        Companion_getInstance_3();
        if (!(7 === (7 & seen0))) {
          throwMissingFieldException(seen0, 7, $serializer_getInstance_3().n4t_1);
        }
        var $this = createThis(this);
        $this.p4t_1 = serialName;
        $this.q4t_1 = annotations;
        $this.r4t_1 = options;
        var tmp = $this;
        // Inline function 'kotlin.collections.map' call
        var this_0 = $this.r4t_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.m1();
        while (_iterator__ex2g4s.n1()) {
          var item = _iterator__ex2g4s.o1();
          var tmp$ret$0 = new (VirtualEnumValue())($this, item.b4u_1);
          destination.v(tmp$ret$0);
        }
        tmp.s4t_1 = destination;
        var tmp_0 = $this;
        // Inline function 'kotlin.collections.associateBy' call
        var this_1 = $this.r4t_1;
        var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
        // Inline function 'kotlin.collections.associateByTo' call
        var destination_0 = LinkedHashMap().fc(capacity);
        var _iterator__ex2g4s_0 = this_1.m1();
        while (_iterator__ex2g4s_0.n1()) {
          var element = _iterator__ex2g4s_0.o1();
          var tmp$ret$3 = element.z4t_1;
          destination_0.s3(tmp$ret$3, element);
        }
        tmp_0.t4t_1 = destination_0;
        var tmp_1 = $this;
        tmp_1.u4t_1 = new (VirtualEnum$1())($this);
        return $this;
      }
    }
    initMetadataForClass($, 'VirtualEnum', VOID, VOID, [VirtualType(), KSerializer()], VOID, VOID, {0: $serializer_getInstance_3});
    VirtualEnumClass = $;
  }
  return VirtualEnumClass;
}
var CompanionClass_4;
function Companion_4() {
  if (CompanionClass_4 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_4();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_4 = $;
  }
  return CompanionClass_4;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  return Companion_instance_4;
}
var $serializerClass_4;
function $serializer_4() {
  if ($serializerClass_4 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_4 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.serialization.VirtualTypeParameter', this, 1);
        tmp0_serialDesc.c1b('name', false);
        this.f4u_1 = tmp0_serialDesc;
      }
      g4u(encoder, value) {
        var tmp0_desc = this.f4u_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.m4t_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.g4u(encoder, value instanceof VirtualTypeParameter() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.f4u_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_input = decoder.l13(tmp0_desc);
        if (tmp5_input.a14()) {
          tmp4_local0 = tmp5_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp5_input.m13(tmp0_desc);
        return VirtualTypeParameter().h4u(tmp3_bitMask0, tmp4_local0, null);
      }
      az() {
        return this.f4u_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_4 = $;
  }
  return $serializerClass_4;
}
var $serializer_instance_4;
function $serializer_getInstance_4() {
  if ($serializer_instance_4 === VOID)
    new ($serializer_4())();
  return $serializer_instance_4;
}
var VirtualTypeParameterClass;
function VirtualTypeParameter() {
  if (VirtualTypeParameterClass === VOID) {
    class $ {
      toString() {
        return 'VirtualTypeParameter(name=' + this.m4t_1 + ')';
      }
      hashCode() {
        return getStringHashCode(this.m4t_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof VirtualTypeParameter()))
          return false;
        if (!(this.m4t_1 === other.m4t_1))
          return false;
        return true;
      }
      static h4u(seen0, name, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_4().f4u_1);
        }
        var $this = createThis(this);
        $this.m4t_1 = name;
        return $this;
      }
    }
    initMetadataForClass($, 'VirtualTypeParameter', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_4});
    VirtualTypeParameterClass = $;
  }
  return VirtualTypeParameterClass;
}
function VirtualAlias$Companion$$childSerializers$_anonymous__bh96hx() {
  return new (ArrayListSerializer())($serializer_getInstance());
}
var CompanionClass_5;
function Companion_5() {
  if (CompanionClass_5 === VOID) {
    class $ {
      constructor() {
        Companion_instance_5 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.o3k_1 = [null, null, lazy(tmp_0, VirtualAlias$Companion$$childSerializers$_anonymous__bh96hx)];
      }
      m2a() {
        return $serializer_getInstance_5();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_5 = $;
  }
  return CompanionClass_5;
}
var Companion_instance_5;
function Companion_getInstance_5() {
  if (Companion_instance_5 === VOID)
    new (Companion_5())();
  return Companion_instance_5;
}
var $serializerClass_5;
function $serializer_5() {
  if ($serializerClass_5 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_5 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.serialization.VirtualAlias', this, 3);
        tmp0_serialDesc.c1b('serialName', false);
        tmp0_serialDesc.c1b('wraps', false);
        tmp0_serialDesc.c1b('annotations', false);
        this.i4u_1 = tmp0_serialDesc;
      }
      j4u(encoder, value) {
        var tmp0_desc = this.i4u_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_5().o3k_1;
        tmp1_output.a15(tmp0_desc, 0, value.k4u_1);
        tmp1_output.c15(tmp0_desc, 1, $serializer_getInstance_1(), value.l4u_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.m4u_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.j4u(encoder, value instanceof VirtualAlias() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.i4u_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.l13(tmp0_desc);
        var tmp8_cached = Companion_getInstance_5().o3k_1;
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.x13(tmp0_desc, 1, $serializer_getInstance_1(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.x13(tmp0_desc, 2, tmp8_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.x13(tmp0_desc, 1, $serializer_getInstance_1(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.x13(tmp0_desc, 2, tmp8_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return VirtualAlias().n4u(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.i4u_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_5().o3k_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), $serializer_getInstance_1(), tmp0_cached[2].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_5 = $;
  }
  return $serializerClass_5;
}
var $serializer_instance_5;
function $serializer_getInstance_5() {
  if ($serializer_instance_5 === VOID)
    new ($serializer_5())();
  return $serializer_instance_5;
}
var VirtualAliasClass;
function VirtualAlias() {
  if (VirtualAliasClass === VOID) {
    class $ {
      bz() {
        return this.m4u_1;
      }
      toString() {
        return 'VirtualAlias(serialName=' + this.k4u_1 + ', wraps=' + this.l4u_1.toString() + ', annotations=' + toString(this.m4u_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.k4u_1);
        result = imul(result, 31) + this.l4u_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.m4u_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof VirtualAlias()))
          return false;
        if (!(this.k4u_1 === other.k4u_1))
          return false;
        if (!this.l4u_1.equals(other.l4u_1))
          return false;
        if (!equals(this.m4u_1, other.m4u_1))
          return false;
        return true;
      }
      static n4u(seen0, serialName, wraps, annotations, serializationConstructorMarker) {
        Companion_getInstance_5();
        if (!(7 === (7 & seen0))) {
          throwMissingFieldException(seen0, 7, $serializer_getInstance_5().i4u_1);
        }
        var $this = createThis(this);
        $this.k4u_1 = serialName;
        $this.l4u_1 = wraps;
        $this.m4u_1 = annotations;
        return $this;
      }
    }
    initMetadataForClass($, 'VirtualAlias', VOID, VOID, [VirtualType()], VOID, VOID, {0: $serializer_getInstance_5});
    VirtualAliasClass = $;
  }
  return VirtualAliasClass;
}
function VirtualEnumOption$Companion$$childSerializers$_anonymous__nmfs4p() {
  return new (ArrayListSerializer())($serializer_getInstance());
}
var CompanionClass_6;
function Companion_6() {
  if (CompanionClass_6 === VOID) {
    class $ {
      constructor() {
        Companion_instance_6 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.s3k_1 = [null, lazy(tmp_0, VirtualEnumOption$Companion$$childSerializers$_anonymous__nmfs4p), null];
      }
      m2a() {
        return $serializer_getInstance_6();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_6 = $;
  }
  return CompanionClass_6;
}
var Companion_instance_6;
function Companion_getInstance_6() {
  if (Companion_instance_6 === VOID)
    new (Companion_6())();
  return Companion_instance_6;
}
var $serializerClass_6;
function $serializer_6() {
  if ($serializerClass_6 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_6 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.serialization.VirtualEnumOption', this, 3);
        tmp0_serialDesc.c1b('name', false);
        tmp0_serialDesc.c1b('annotations', false);
        tmp0_serialDesc.c1b('index', false);
        this.o4u_1 = tmp0_serialDesc;
      }
      p4u(encoder, value) {
        var tmp0_desc = this.o4u_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_6().s3k_1;
        tmp1_output.a15(tmp0_desc, 0, value.z4t_1);
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.a4u_1);
        tmp1_output.v14(tmp0_desc, 2, value.b4u_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.p4u(encoder, value instanceof VirtualEnumOption() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.o4u_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = 0;
        var tmp7_input = decoder.l13(tmp0_desc);
        var tmp8_cached = Companion_getInstance_6().s3k_1;
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.x13(tmp0_desc, 1, tmp8_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.q13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.x13(tmp0_desc, 1, tmp8_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.q13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return VirtualEnumOption().q4u(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.o4u_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_6().s3k_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), tmp0_cached[1].f2(), IntSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_6 = $;
  }
  return $serializerClass_6;
}
var $serializer_instance_6;
function $serializer_getInstance_6() {
  if ($serializer_instance_6 === VOID)
    new ($serializer_6())();
  return $serializer_instance_6;
}
var VirtualEnumOptionClass;
function VirtualEnumOption() {
  if (VirtualEnumOptionClass === VOID) {
    class $ {
      toString() {
        return 'VirtualEnumOption(name=' + this.z4t_1 + ', annotations=' + toString(this.a4u_1) + ', index=' + this.b4u_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.z4t_1);
        result = imul(result, 31) + hashCode(this.a4u_1) | 0;
        result = imul(result, 31) + this.b4u_1 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof VirtualEnumOption()))
          return false;
        if (!(this.z4t_1 === other.z4t_1))
          return false;
        if (!equals(this.a4u_1, other.a4u_1))
          return false;
        if (!(this.b4u_1 === other.b4u_1))
          return false;
        return true;
      }
      static q4u(seen0, name, annotations, index, serializationConstructorMarker) {
        Companion_getInstance_6();
        if (!(7 === (7 & seen0))) {
          throwMissingFieldException(seen0, 7, $serializer_getInstance_6().o4u_1);
        }
        var $this = createThis(this);
        $this.z4t_1 = name;
        $this.a4u_1 = annotations;
        $this.b4u_1 = index;
        return $this;
      }
    }
    initMetadataForClass($, 'VirtualEnumOption', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_6});
    VirtualEnumOptionClass = $;
  }
  return VirtualEnumOptionClass;
}
function _get_$cachedSerializer__te6jhj($this) {
  return $this.v3k_1.f2();
}
function SerializableAnnotationValue$NullValue$_anonymous__fpge3y() {
  var tmp = NullValue_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ObjectSerializer().g1c('com.lightningkite.serialization.SerializableAnnotationValue.NullValue', tmp, tmp$ret$2);
}
var CompanionClass_7;
function Companion_7() {
  if (CompanionClass_7 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_7();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_7 = $;
  }
  return CompanionClass_7;
}
var Companion_instance_7;
function Companion_getInstance_7() {
  return Companion_instance_7;
}
var $serializerClass_7;
function $serializer_7() {
  if ($serializerClass_7 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_7 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.serialization.SerializableAnnotationValue.BooleanValue', this, 1);
        tmp0_serialDesc.c1b('value', false);
        this.r4u_1 = tmp0_serialDesc;
      }
      s4u(encoder, value) {
        var tmp0_desc = this.r4u_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.s14(tmp0_desc, 0, value.t4u_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.s4u(encoder, value instanceof BooleanValue() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.r4u_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = false;
        var tmp5_input = decoder.l13(tmp0_desc);
        if (tmp5_input.a14()) {
          tmp4_local0 = tmp5_input.n13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.n13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp5_input.m13(tmp0_desc);
        return BooleanValue().u4u(tmp3_bitMask0, tmp4_local0, null);
      }
      az() {
        return this.r4u_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [BooleanSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_7 = $;
  }
  return $serializerClass_7;
}
var $serializer_instance_7;
function $serializer_getInstance_7() {
  if ($serializer_instance_7 === VOID)
    new ($serializer_7())();
  return $serializer_instance_7;
}
var CompanionClass_8;
function Companion_8() {
  if (CompanionClass_8 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_8();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_8 = $;
  }
  return CompanionClass_8;
}
var Companion_instance_8;
function Companion_getInstance_8() {
  return Companion_instance_8;
}
var $serializerClass_8;
function $serializer_8() {
  if ($serializerClass_8 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_8 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.serialization.SerializableAnnotationValue.ByteValue', this, 1);
        tmp0_serialDesc.c1b('value', false);
        this.v4u_1 = tmp0_serialDesc;
      }
      w4u(encoder, value) {
        var tmp0_desc = this.v4u_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.t14(tmp0_desc, 0, value.x4u_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.w4u(encoder, value instanceof ByteValue() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.v4u_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = 0;
        var tmp5_input = decoder.l13(tmp0_desc);
        if (tmp5_input.a14()) {
          tmp4_local0 = tmp5_input.o13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.o13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp5_input.m13(tmp0_desc);
        return ByteValue().y4u(tmp3_bitMask0, tmp4_local0, null);
      }
      az() {
        return this.v4u_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [ByteSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_8 = $;
  }
  return $serializerClass_8;
}
var $serializer_instance_8;
function $serializer_getInstance_8() {
  if ($serializer_instance_8 === VOID)
    new ($serializer_8())();
  return $serializer_instance_8;
}
var CompanionClass_9;
function Companion_9() {
  if (CompanionClass_9 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_9();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_9 = $;
  }
  return CompanionClass_9;
}
var Companion_instance_9;
function Companion_getInstance_9() {
  return Companion_instance_9;
}
var $serializerClass_9;
function $serializer_9() {
  if ($serializerClass_9 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_9 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.serialization.SerializableAnnotationValue.ShortValue', this, 1);
        tmp0_serialDesc.c1b('value', false);
        this.z4u_1 = tmp0_serialDesc;
      }
      a4v(encoder, value) {
        var tmp0_desc = this.z4u_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.u14(tmp0_desc, 0, value.b4v_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.a4v(encoder, value instanceof ShortValue() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.z4u_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = 0;
        var tmp5_input = decoder.l13(tmp0_desc);
        if (tmp5_input.a14()) {
          tmp4_local0 = tmp5_input.p13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.p13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp5_input.m13(tmp0_desc);
        return ShortValue().c4v(tmp3_bitMask0, tmp4_local0, null);
      }
      az() {
        return this.z4u_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [ShortSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_9 = $;
  }
  return $serializerClass_9;
}
var $serializer_instance_9;
function $serializer_getInstance_9() {
  if ($serializer_instance_9 === VOID)
    new ($serializer_9())();
  return $serializer_instance_9;
}
var CompanionClass_10;
function Companion_10() {
  if (CompanionClass_10 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_10();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_10 = $;
  }
  return CompanionClass_10;
}
var Companion_instance_10;
function Companion_getInstance_10() {
  return Companion_instance_10;
}
var $serializerClass_10;
function $serializer_10() {
  if ($serializerClass_10 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_10 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.serialization.SerializableAnnotationValue.IntValue', this, 1);
        tmp0_serialDesc.c1b('value', false);
        this.d4v_1 = tmp0_serialDesc;
      }
      e4v(encoder, value) {
        var tmp0_desc = this.d4v_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.v14(tmp0_desc, 0, value.f4v_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.e4v(encoder, value instanceof IntValue() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.d4v_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = 0;
        var tmp5_input = decoder.l13(tmp0_desc);
        if (tmp5_input.a14()) {
          tmp4_local0 = tmp5_input.q13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.q13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp5_input.m13(tmp0_desc);
        return IntValue().g4v(tmp3_bitMask0, tmp4_local0, null);
      }
      az() {
        return this.d4v_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [IntSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_10 = $;
  }
  return $serializerClass_10;
}
var $serializer_instance_10;
function $serializer_getInstance_10() {
  if ($serializer_instance_10 === VOID)
    new ($serializer_10())();
  return $serializer_instance_10;
}
var CompanionClass_11;
function Companion_11() {
  if (CompanionClass_11 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_11();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_11 = $;
  }
  return CompanionClass_11;
}
var Companion_instance_11;
function Companion_getInstance_11() {
  return Companion_instance_11;
}
var $serializerClass_11;
function $serializer_11() {
  if ($serializerClass_11 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_11 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.serialization.SerializableAnnotationValue.LongValue', this, 1);
        tmp0_serialDesc.c1b('value', false);
        this.h4v_1 = tmp0_serialDesc;
      }
      i4v(encoder, value) {
        var tmp0_desc = this.h4v_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.w14(tmp0_desc, 0, value.j4v_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.i4v(encoder, value instanceof LongValue() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.h4v_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = 0n;
        var tmp5_input = decoder.l13(tmp0_desc);
        if (tmp5_input.a14()) {
          tmp4_local0 = tmp5_input.r13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.r13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp5_input.m13(tmp0_desc);
        return LongValue().k4v(tmp3_bitMask0, tmp4_local0, null);
      }
      az() {
        return this.h4v_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [LongSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_11 = $;
  }
  return $serializerClass_11;
}
var $serializer_instance_11;
function $serializer_getInstance_11() {
  if ($serializer_instance_11 === VOID)
    new ($serializer_11())();
  return $serializer_instance_11;
}
var CompanionClass_12;
function Companion_12() {
  if (CompanionClass_12 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_12();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_12 = $;
  }
  return CompanionClass_12;
}
var Companion_instance_12;
function Companion_getInstance_12() {
  return Companion_instance_12;
}
var $serializerClass_12;
function $serializer_12() {
  if ($serializerClass_12 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_12 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.serialization.SerializableAnnotationValue.FloatValue', this, 1);
        tmp0_serialDesc.c1b('value', false);
        this.l4v_1 = tmp0_serialDesc;
      }
      m4v(encoder, value) {
        var tmp0_desc = this.l4v_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.x14(tmp0_desc, 0, value.n4v_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.m4v(encoder, value instanceof FloatValue() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.l4v_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = 0.0;
        var tmp5_input = decoder.l13(tmp0_desc);
        if (tmp5_input.a14()) {
          tmp4_local0 = tmp5_input.s13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.s13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp5_input.m13(tmp0_desc);
        return FloatValue().o4v(tmp3_bitMask0, tmp4_local0, null);
      }
      az() {
        return this.l4v_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [FloatSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_12 = $;
  }
  return $serializerClass_12;
}
var $serializer_instance_12;
function $serializer_getInstance_12() {
  if ($serializer_instance_12 === VOID)
    new ($serializer_12())();
  return $serializer_instance_12;
}
var CompanionClass_13;
function Companion_13() {
  if (CompanionClass_13 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_13();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_13 = $;
  }
  return CompanionClass_13;
}
var Companion_instance_13;
function Companion_getInstance_13() {
  return Companion_instance_13;
}
var $serializerClass_13;
function $serializer_13() {
  if ($serializerClass_13 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_13 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.serialization.SerializableAnnotationValue.DoubleValue', this, 1);
        tmp0_serialDesc.c1b('value', false);
        this.p4v_1 = tmp0_serialDesc;
      }
      q4v(encoder, value) {
        var tmp0_desc = this.p4v_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.y14(tmp0_desc, 0, value.r4v_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.q4v(encoder, value instanceof DoubleValue() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.p4v_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = 0.0;
        var tmp5_input = decoder.l13(tmp0_desc);
        if (tmp5_input.a14()) {
          tmp4_local0 = tmp5_input.t13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.t13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp5_input.m13(tmp0_desc);
        return DoubleValue().s4v(tmp3_bitMask0, tmp4_local0, null);
      }
      az() {
        return this.p4v_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DoubleSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_13 = $;
  }
  return $serializerClass_13;
}
var $serializer_instance_13;
function $serializer_getInstance_13() {
  if ($serializer_instance_13 === VOID)
    new ($serializer_13())();
  return $serializer_instance_13;
}
var CompanionClass_14;
function Companion_14() {
  if (CompanionClass_14 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_14();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_14 = $;
  }
  return CompanionClass_14;
}
var Companion_instance_14;
function Companion_getInstance_14() {
  return Companion_instance_14;
}
var $serializerClass_14;
function $serializer_14() {
  if ($serializerClass_14 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_14 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.serialization.SerializableAnnotationValue.CharValue', this, 1);
        tmp0_serialDesc.c1b('value', false);
        this.t4v_1 = tmp0_serialDesc;
      }
      u4v(encoder, value) {
        var tmp0_desc = this.t4v_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.z14(tmp0_desc, 0, value.v4v_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.u4v(encoder, value instanceof CharValue() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.t4v_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = _Char___init__impl__6a9atx(0);
        var tmp5_input = decoder.l13(tmp0_desc);
        if (tmp5_input.a14()) {
          tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp5_input.m13(tmp0_desc);
        return CharValue().w4v(tmp3_bitMask0, tmp4_local0, null);
      }
      az() {
        return this.t4v_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [CharSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_14 = $;
  }
  return $serializerClass_14;
}
var $serializer_instance_14;
function $serializer_getInstance_14() {
  if ($serializer_instance_14 === VOID)
    new ($serializer_14())();
  return $serializer_instance_14;
}
var CompanionClass_15;
function Companion_15() {
  if (CompanionClass_15 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_15();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_15 = $;
  }
  return CompanionClass_15;
}
var Companion_instance_15;
function Companion_getInstance_15() {
  return Companion_instance_15;
}
var $serializerClass_15;
function $serializer_15() {
  if ($serializerClass_15 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_15 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.serialization.SerializableAnnotationValue.StringValue', this, 1);
        tmp0_serialDesc.c1b('value', false);
        this.x4v_1 = tmp0_serialDesc;
      }
      y4v(encoder, value) {
        var tmp0_desc = this.x4v_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.z4v_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.y4v(encoder, value instanceof StringValue() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.x4v_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_input = decoder.l13(tmp0_desc);
        if (tmp5_input.a14()) {
          tmp4_local0 = tmp5_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp5_input.m13(tmp0_desc);
        return StringValue().a4w(tmp3_bitMask0, tmp4_local0, null);
      }
      az() {
        return this.x4v_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_15 = $;
  }
  return $serializerClass_15;
}
var $serializer_instance_15;
function $serializer_getInstance_15() {
  if ($serializer_instance_15 === VOID)
    new ($serializer_15())();
  return $serializer_instance_15;
}
var CompanionClass_16;
function Companion_16() {
  if (CompanionClass_16 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_16();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_16 = $;
  }
  return CompanionClass_16;
}
var Companion_instance_16;
function Companion_getInstance_16() {
  return Companion_instance_16;
}
var $serializerClass_16;
function $serializer_16() {
  if ($serializerClass_16 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_16 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.serialization.SerializableAnnotationValue.ClassValue', this, 1);
        tmp0_serialDesc.c1b('fqn', false);
        this.b4w_1 = tmp0_serialDesc;
      }
      c4w(encoder, value) {
        var tmp0_desc = this.b4w_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.d4w_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.c4w(encoder, value instanceof ClassValue() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.b4w_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_input = decoder.l13(tmp0_desc);
        if (tmp5_input.a14()) {
          tmp4_local0 = tmp5_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp5_input.m13(tmp0_desc);
        return ClassValue().e4w(tmp3_bitMask0, tmp4_local0, null);
      }
      az() {
        return this.b4w_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_16 = $;
  }
  return $serializerClass_16;
}
var $serializer_instance_16;
function $serializer_getInstance_16() {
  if ($serializer_instance_16 === VOID)
    new ($serializer_16())();
  return $serializer_instance_16;
}
function SerializableAnnotationValue$ArrayValue$Companion$$childSerializers$_anonymous__qu4khd() {
  return new (ArrayListSerializer())(Companion_getInstance_18().m2a());
}
var CompanionClass_17;
function Companion_17() {
  if (CompanionClass_17 === VOID) {
    class $ {
      constructor() {
        Companion_instance_17 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.w3k_1 = [lazy(tmp_0, SerializableAnnotationValue$ArrayValue$Companion$$childSerializers$_anonymous__qu4khd)];
      }
      m2a() {
        return $serializer_getInstance_17();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_17 = $;
  }
  return CompanionClass_17;
}
var Companion_instance_17;
function Companion_getInstance_17() {
  if (Companion_instance_17 === VOID)
    new (Companion_17())();
  return Companion_instance_17;
}
var $serializerClass_17;
function $serializer_17() {
  if ($serializerClass_17 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_17 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.serialization.SerializableAnnotationValue.ArrayValue', this, 1);
        tmp0_serialDesc.c1b('value', false);
        this.f4w_1 = tmp0_serialDesc;
      }
      g4w(encoder, value) {
        var tmp0_desc = this.f4w_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_17().w3k_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.h4w_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.g4w(encoder, value instanceof ArrayValue() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.f4w_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_input = decoder.l13(tmp0_desc);
        var tmp6_cached = Companion_getInstance_17().w3k_1;
        if (tmp5_input.a14()) {
          tmp4_local0 = tmp5_input.x13(tmp0_desc, 0, tmp6_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.x13(tmp0_desc, 0, tmp6_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp5_input.m13(tmp0_desc);
        return ArrayValue().i4w(tmp3_bitMask0, tmp4_local0, null);
      }
      az() {
        return this.f4w_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [Companion_getInstance_17().w3k_1[0].f2()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_17 = $;
  }
  return $serializerClass_17;
}
var $serializer_instance_17;
function $serializer_getInstance_17() {
  if ($serializer_instance_17 === VOID)
    new ($serializer_17())();
  return $serializer_instance_17;
}
function _get_$cachedSerializer__te6jhj_0($this) {
  return $this.m3h_1.f2();
}
function SerializableAnnotationValue$Companion$_anonymous__pdu2do() {
  var tmp = getKClass(SerializableAnnotationValue());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [getKClass(ArrayValue()), getKClass(BooleanValue()), getKClass(ByteValue()), getKClass(CharValue()), getKClass(ClassValue()), getKClass(DoubleValue()), getKClass(FloatValue()), getKClass(IntValue()), getKClass(LongValue()), getKClass(NullValue()), getKClass(ShortValue()), getKClass(StringValue())];
  var tmp_1 = $serializer_getInstance_17();
  var tmp_2 = $serializer_getInstance_7();
  var tmp_3 = $serializer_getInstance_8();
  var tmp_4 = $serializer_getInstance_14();
  var tmp_5 = $serializer_getInstance_16();
  var tmp_6 = $serializer_getInstance_13();
  var tmp_7 = $serializer_getInstance_12();
  var tmp_8 = $serializer_getInstance_10();
  var tmp_9 = $serializer_getInstance_11();
  var tmp_10 = NullValue_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_11 = [tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, ObjectSerializer().g1c('com.lightningkite.serialization.SerializableAnnotationValue.NullValue', tmp_10, tmp$ret$5), $serializer_getInstance_9(), $serializer_getInstance_15()];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$11 = [];
  return SealedClassSerializer().j10('com.lightningkite.serialization.SerializableAnnotationValue', tmp, tmp_0, tmp_11, tmp$ret$11);
}
var NullValueClass;
function NullValue() {
  if (NullValueClass === VOID) {
    class $ extends SerializableAnnotationValue() {
      constructor() {
        NullValue_instance = null;
        super();
        NullValue_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.v3k_1 = lazy(tmp_0, SerializableAnnotationValue$NullValue$_anonymous__fpge3y);
      }
      m2a() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      h1c(typeParamsSerializers) {
        return this.m2a();
      }
      toString() {
        return 'NullValue';
      }
      hashCode() {
        return -1421390785;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof NullValue()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'NullValue', VOID, VOID, [SerializableAnnotationValue(), SerializerFactory()], VOID, VOID, {0: NullValue_getInstance});
    NullValueClass = $;
  }
  return NullValueClass;
}
var NullValue_instance;
function NullValue_getInstance() {
  if (NullValue_instance === VOID)
    new (NullValue())();
  return NullValue_instance;
}
var BooleanValueClass;
function BooleanValue() {
  if (BooleanValueClass === VOID) {
    class $ extends SerializableAnnotationValue() {
      constructor(value) {
        super();
        this.t4u_1 = value;
      }
      toString() {
        return 'BooleanValue(value=' + this.t4u_1 + ')';
      }
      hashCode() {
        return getBooleanHashCode(this.t4u_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof BooleanValue()))
          return false;
        if (!(this.t4u_1 === other.t4u_1))
          return false;
        return true;
      }
      static u4u(seen0, value, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_7().r4u_1);
        }
        var $this = this.j4w(seen0, serializationConstructorMarker);
        $this.t4u_1 = value;
        return $this;
      }
    }
    initMetadataForClass($, 'BooleanValue', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_7});
    BooleanValueClass = $;
  }
  return BooleanValueClass;
}
var ByteValueClass;
function ByteValue() {
  if (ByteValueClass === VOID) {
    class $ extends SerializableAnnotationValue() {
      constructor(value) {
        super();
        this.x4u_1 = value;
      }
      toString() {
        return 'ByteValue(value=' + this.x4u_1 + ')';
      }
      hashCode() {
        return this.x4u_1;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ByteValue()))
          return false;
        if (!(this.x4u_1 === other.x4u_1))
          return false;
        return true;
      }
      static y4u(seen0, value, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_8().v4u_1);
        }
        var $this = this.j4w(seen0, serializationConstructorMarker);
        $this.x4u_1 = value;
        return $this;
      }
    }
    initMetadataForClass($, 'ByteValue', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_8});
    ByteValueClass = $;
  }
  return ByteValueClass;
}
var ShortValueClass;
function ShortValue() {
  if (ShortValueClass === VOID) {
    class $ extends SerializableAnnotationValue() {
      constructor(value) {
        super();
        this.b4v_1 = value;
      }
      toString() {
        return 'ShortValue(value=' + this.b4v_1 + ')';
      }
      hashCode() {
        return this.b4v_1;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ShortValue()))
          return false;
        if (!(this.b4v_1 === other.b4v_1))
          return false;
        return true;
      }
      static c4v(seen0, value, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_9().z4u_1);
        }
        var $this = this.j4w(seen0, serializationConstructorMarker);
        $this.b4v_1 = value;
        return $this;
      }
    }
    initMetadataForClass($, 'ShortValue', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_9});
    ShortValueClass = $;
  }
  return ShortValueClass;
}
var IntValueClass;
function IntValue() {
  if (IntValueClass === VOID) {
    class $ extends SerializableAnnotationValue() {
      constructor(value) {
        super();
        this.f4v_1 = value;
      }
      toString() {
        return 'IntValue(value=' + this.f4v_1 + ')';
      }
      hashCode() {
        return this.f4v_1;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof IntValue()))
          return false;
        if (!(this.f4v_1 === other.f4v_1))
          return false;
        return true;
      }
      static g4v(seen0, value, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_10().d4v_1);
        }
        var $this = this.j4w(seen0, serializationConstructorMarker);
        $this.f4v_1 = value;
        return $this;
      }
    }
    initMetadataForClass($, 'IntValue', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_10});
    IntValueClass = $;
  }
  return IntValueClass;
}
var LongValueClass;
function LongValue() {
  if (LongValueClass === VOID) {
    class $ extends SerializableAnnotationValue() {
      constructor(value) {
        super();
        this.j4v_1 = value;
      }
      toString() {
        return 'LongValue(value=' + this.j4v_1.toString() + ')';
      }
      hashCode() {
        return getBigIntHashCode(this.j4v_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LongValue()))
          return false;
        if (!(this.j4v_1 === other.j4v_1))
          return false;
        return true;
      }
      static k4v(seen0, value, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_11().h4v_1);
        }
        var $this = this.j4w(seen0, serializationConstructorMarker);
        $this.j4v_1 = value;
        return $this;
      }
    }
    initMetadataForClass($, 'LongValue', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_11});
    LongValueClass = $;
  }
  return LongValueClass;
}
var FloatValueClass;
function FloatValue() {
  if (FloatValueClass === VOID) {
    class $ extends SerializableAnnotationValue() {
      constructor(value) {
        super();
        this.n4v_1 = value;
      }
      toString() {
        return 'FloatValue(value=' + this.n4v_1 + ')';
      }
      hashCode() {
        return getNumberHashCode(this.n4v_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FloatValue()))
          return false;
        if (!equals(this.n4v_1, other.n4v_1))
          return false;
        return true;
      }
      static o4v(seen0, value, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_12().l4v_1);
        }
        var $this = this.j4w(seen0, serializationConstructorMarker);
        $this.n4v_1 = value;
        return $this;
      }
    }
    initMetadataForClass($, 'FloatValue', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_12});
    FloatValueClass = $;
  }
  return FloatValueClass;
}
var DoubleValueClass;
function DoubleValue() {
  if (DoubleValueClass === VOID) {
    class $ extends SerializableAnnotationValue() {
      constructor(value) {
        super();
        this.r4v_1 = value;
      }
      toString() {
        return 'DoubleValue(value=' + this.r4v_1 + ')';
      }
      hashCode() {
        return getNumberHashCode(this.r4v_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DoubleValue()))
          return false;
        if (!equals(this.r4v_1, other.r4v_1))
          return false;
        return true;
      }
      static s4v(seen0, value, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_13().p4v_1);
        }
        var $this = this.j4w(seen0, serializationConstructorMarker);
        $this.r4v_1 = value;
        return $this;
      }
    }
    initMetadataForClass($, 'DoubleValue', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_13});
    DoubleValueClass = $;
  }
  return DoubleValueClass;
}
var CharValueClass;
function CharValue() {
  if (CharValueClass === VOID) {
    class $ extends SerializableAnnotationValue() {
      constructor(value) {
        super();
        this.v4v_1 = value;
      }
      toString() {
        return 'CharValue(value=' + toString_0(this.v4v_1) + ')';
      }
      hashCode() {
        return Char__hashCode_impl_otmys(this.v4v_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CharValue()))
          return false;
        if (!(this.v4v_1 === other.v4v_1))
          return false;
        return true;
      }
      static w4v(seen0, value, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_14().t4v_1);
        }
        var $this = this.j4w(seen0, serializationConstructorMarker);
        $this.v4v_1 = value;
        return $this;
      }
    }
    initMetadataForClass($, 'CharValue', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_14});
    CharValueClass = $;
  }
  return CharValueClass;
}
var StringValueClass;
function StringValue() {
  if (StringValueClass === VOID) {
    class $ extends SerializableAnnotationValue() {
      constructor(value) {
        super();
        this.z4v_1 = value;
      }
      toString() {
        return 'StringValue(value=' + this.z4v_1 + ')';
      }
      hashCode() {
        return getStringHashCode(this.z4v_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof StringValue()))
          return false;
        if (!(this.z4v_1 === other.z4v_1))
          return false;
        return true;
      }
      static a4w(seen0, value, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_15().x4v_1);
        }
        var $this = this.j4w(seen0, serializationConstructorMarker);
        $this.z4v_1 = value;
        return $this;
      }
    }
    initMetadataForClass($, 'StringValue', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_15});
    StringValueClass = $;
  }
  return StringValueClass;
}
var ClassValueClass;
function ClassValue() {
  if (ClassValueClass === VOID) {
    class $ extends SerializableAnnotationValue() {
      constructor(fqn) {
        super();
        this.d4w_1 = fqn;
      }
      toString() {
        return 'ClassValue(fqn=' + this.d4w_1 + ')';
      }
      hashCode() {
        return getStringHashCode(this.d4w_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ClassValue()))
          return false;
        if (!(this.d4w_1 === other.d4w_1))
          return false;
        return true;
      }
      static e4w(seen0, fqn, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_16().b4w_1);
        }
        var $this = this.j4w(seen0, serializationConstructorMarker);
        $this.d4w_1 = fqn;
        return $this;
      }
    }
    initMetadataForClass($, 'ClassValue', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_16});
    ClassValueClass = $;
  }
  return ClassValueClass;
}
var ArrayValueClass;
function ArrayValue() {
  if (ArrayValueClass === VOID) {
    class $ extends SerializableAnnotationValue() {
      constructor(value) {
        Companion_getInstance_17();
        super();
        this.h4w_1 = value;
      }
      toString() {
        return 'ArrayValue(value=' + toString(this.h4w_1) + ')';
      }
      hashCode() {
        return hashCode(this.h4w_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ArrayValue()))
          return false;
        if (!equals(this.h4w_1, other.h4w_1))
          return false;
        return true;
      }
      static i4w(seen0, value, serializationConstructorMarker) {
        Companion_getInstance_17();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_17().f4w_1);
        }
        var $this = this.j4w(seen0, serializationConstructorMarker);
        $this.h4w_1 = value;
        return $this;
      }
    }
    initMetadataForClass($, 'ArrayValue', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_17});
    ArrayValueClass = $;
  }
  return ArrayValueClass;
}
var CompanionClass_18;
function Companion_18() {
  if (CompanionClass_18 === VOID) {
    class $ {
      constructor() {
        Companion_instance_18 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.m3h_1 = lazy(tmp_0, SerializableAnnotationValue$Companion$_anonymous__pdu2do);
      }
      n3h(value) {
        var tmp;
        if (value == null) {
          tmp = NullValue_getInstance();
        } else {
          if (typeof value === 'boolean') {
            tmp = new (BooleanValue())(value);
          } else {
            if (typeof value === 'number') {
              tmp = new (ByteValue())(value);
            } else {
              if (typeof value === 'number') {
                tmp = new (ShortValue())(value);
              } else {
                if (typeof value === 'number') {
                  tmp = new (IntValue())(value);
                } else {
                  if (typeof value === 'bigint') {
                    tmp = new (LongValue())(value);
                  } else {
                    if (typeof value === 'number') {
                      tmp = new (FloatValue())(value);
                    } else {
                      if (typeof value === 'number') {
                        tmp = new (DoubleValue())(value);
                      } else {
                        if (value instanceof Char()) {
                          tmp = new (CharValue())(value.z2_1);
                        } else {
                          if (typeof value === 'string') {
                            tmp = new (StringValue())(value);
                          } else {
                            if (isInterface(value, KClass())) {
                              var tmp1_safe_receiver = serializerOrNull(value);
                              var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.az();
                              var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.h10();
                              tmp = new (ClassValue())(tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs);
                            } else {
                              if (isBooleanArray(value)) {
                                // Inline function 'kotlin.collections.map' call
                                // Inline function 'kotlin.collections.mapTo' call
                                var destination = ArrayList().u(value.length);
                                var inductionVariable = 0;
                                var last = value.length;
                                while (inductionVariable < last) {
                                  var item = value[inductionVariable];
                                  inductionVariable = inductionVariable + 1 | 0;
                                  var tmp$ret$0 = Companion_getInstance_18().n3h(item);
                                  destination.v(tmp$ret$0);
                                }
                                tmp = new (ArrayValue())(destination);
                              } else {
                                if (isByteArray(value)) {
                                  // Inline function 'kotlin.collections.map' call
                                  // Inline function 'kotlin.collections.mapTo' call
                                  var destination_0 = ArrayList().u(value.length);
                                  var inductionVariable_0 = 0;
                                  var last_0 = value.length;
                                  while (inductionVariable_0 < last_0) {
                                    var item_0 = value[inductionVariable_0];
                                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                                    var tmp$ret$3 = Companion_getInstance_18().n3h(item_0);
                                    destination_0.v(tmp$ret$3);
                                  }
                                  tmp = new (ArrayValue())(destination_0);
                                } else {
                                  if (isShortArray(value)) {
                                    // Inline function 'kotlin.collections.map' call
                                    // Inline function 'kotlin.collections.mapTo' call
                                    var destination_1 = ArrayList().u(value.length);
                                    var inductionVariable_1 = 0;
                                    var last_1 = value.length;
                                    while (inductionVariable_1 < last_1) {
                                      var item_1 = value[inductionVariable_1];
                                      inductionVariable_1 = inductionVariable_1 + 1 | 0;
                                      var tmp$ret$6 = Companion_getInstance_18().n3h(item_1);
                                      destination_1.v(tmp$ret$6);
                                    }
                                    tmp = new (ArrayValue())(destination_1);
                                  } else {
                                    if (isIntArray(value)) {
                                      // Inline function 'kotlin.collections.map' call
                                      // Inline function 'kotlin.collections.mapTo' call
                                      var destination_2 = ArrayList().u(value.length);
                                      var inductionVariable_2 = 0;
                                      var last_2 = value.length;
                                      while (inductionVariable_2 < last_2) {
                                        var item_2 = value[inductionVariable_2];
                                        inductionVariable_2 = inductionVariable_2 + 1 | 0;
                                        var tmp$ret$9 = Companion_getInstance_18().n3h(item_2);
                                        destination_2.v(tmp$ret$9);
                                      }
                                      tmp = new (ArrayValue())(destination_2);
                                    } else {
                                      if (isLongArray(value)) {
                                        // Inline function 'kotlin.collections.map' call
                                        // Inline function 'kotlin.collections.mapTo' call
                                        var destination_3 = ArrayList().u(value.length);
                                        var inductionVariable_3 = 0;
                                        var last_3 = value.length;
                                        while (inductionVariable_3 < last_3) {
                                          var item_3 = value[inductionVariable_3];
                                          inductionVariable_3 = inductionVariable_3 + 1 | 0;
                                          var tmp$ret$12 = Companion_getInstance_18().n3h(item_3);
                                          destination_3.v(tmp$ret$12);
                                        }
                                        tmp = new (ArrayValue())(destination_3);
                                      } else {
                                        if (isFloatArray(value)) {
                                          // Inline function 'kotlin.collections.map' call
                                          // Inline function 'kotlin.collections.mapTo' call
                                          var destination_4 = ArrayList().u(value.length);
                                          var inductionVariable_4 = 0;
                                          var last_4 = value.length;
                                          while (inductionVariable_4 < last_4) {
                                            var item_4 = value[inductionVariable_4];
                                            inductionVariable_4 = inductionVariable_4 + 1 | 0;
                                            var tmp$ret$15 = Companion_getInstance_18().n3h(item_4);
                                            destination_4.v(tmp$ret$15);
                                          }
                                          tmp = new (ArrayValue())(destination_4);
                                        } else {
                                          if (isDoubleArray(value)) {
                                            // Inline function 'kotlin.collections.map' call
                                            // Inline function 'kotlin.collections.mapTo' call
                                            var destination_5 = ArrayList().u(value.length);
                                            var inductionVariable_5 = 0;
                                            var last_5 = value.length;
                                            while (inductionVariable_5 < last_5) {
                                              var item_5 = value[inductionVariable_5];
                                              inductionVariable_5 = inductionVariable_5 + 1 | 0;
                                              var tmp$ret$18 = Companion_getInstance_18().n3h(item_5);
                                              destination_5.v(tmp$ret$18);
                                            }
                                            tmp = new (ArrayValue())(destination_5);
                                          } else {
                                            if (isCharArray(value)) {
                                              // Inline function 'kotlin.collections.map' call
                                              // Inline function 'kotlin.collections.mapTo' call
                                              var destination_6 = ArrayList().u(value.length);
                                              var inductionVariable_6 = 0;
                                              var last_6 = value.length;
                                              while (inductionVariable_6 < last_6) {
                                                var item_6 = value[inductionVariable_6];
                                                inductionVariable_6 = inductionVariable_6 + 1 | 0;
                                                var tmp$ret$21 = Companion_getInstance_18().n3h(new (Char())(item_6));
                                                destination_6.v(tmp$ret$21);
                                              }
                                              tmp = new (ArrayValue())(destination_6);
                                            } else {
                                              if (isArray(value)) {
                                                // Inline function 'kotlin.collections.map' call
                                                // Inline function 'kotlin.collections.mapTo' call
                                                var destination_7 = ArrayList().u(value.length);
                                                var inductionVariable_7 = 0;
                                                var last_7 = value.length;
                                                while (inductionVariable_7 < last_7) {
                                                  var item_7 = value[inductionVariable_7];
                                                  inductionVariable_7 = inductionVariable_7 + 1 | 0;
                                                  var tmp$ret$24 = Companion_getInstance_18().n3h(item_7);
                                                  destination_7.v(tmp$ret$24);
                                                }
                                                tmp = new (ArrayValue())(destination_7);
                                              } else {
                                                tmp = NullValue_getInstance();
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        return tmp;
      }
      m2a() {
        return _get_$cachedSerializer__te6jhj_0(this);
      }
      h1c(typeParamsSerializers) {
        return this.m2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_18 = $;
  }
  return CompanionClass_18;
}
var Companion_instance_18;
function Companion_getInstance_18() {
  if (Companion_instance_18 === VOID)
    new (Companion_18())();
  return Companion_instance_18;
}
var SerializableAnnotationValueClass;
function SerializableAnnotationValue() {
  if (SerializableAnnotationValueClass === VOID) {
    class $ {
      constructor() {
        Companion_getInstance_18();
      }
      static j4w(seen0, serializationConstructorMarker) {
        Companion_getInstance_18();
        return createThis(this);
      }
    }
    initMetadataForClass($, 'SerializableAnnotationValue', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_18});
    SerializableAnnotationValueClass = $;
  }
  return SerializableAnnotationValueClass;
}
var VirtualEnumValueClass;
function VirtualEnumValue() {
  if (VirtualEnumValueClass === VOID) {
    class $ {
      constructor(enum_0, index) {
        this.d4u_1 = enum_0;
        this.e4u_1 = index;
      }
      k4w(other) {
        return compareTo(this.e4u_1, other.e4u_1);
      }
      d(other) {
        return this.k4w(other instanceof VirtualEnumValue() ? other : THROW_CCE());
      }
      toString() {
        return this.d4u_1.r4t_1.q1(this.e4u_1).z4t_1;
      }
    }
    initMetadataForClass($, 'VirtualEnumValue', VOID, VOID, [Comparable()]);
    VirtualEnumValueClass = $;
  }
  return VirtualEnumValueClass;
}
function get_serializableAnnotations(_this__u8e3s4) {
  _init_properties_VirtualType_kt__467cct();
  var tmp;
  if (isInterface(_this__u8e3s4, VirtualType())) {
    tmp = _this__u8e3s4.bz();
  } else {
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0 = _this__u8e3s4.az().bz();
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList().w();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp0_safe_receiver = Companion_getInstance().q4r(element);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.v(tmp0_safe_receiver);
      }
    }
    tmp = destination;
  }
  return tmp;
}
function getElementSerializableAnnotations(_this__u8e3s4, index) {
  _init_properties_VirtualType_kt__467cct();
  var tmp;
  if (_this__u8e3s4 instanceof Concrete()) {
    tmp = _this__u8e3s4.r4r_1.i4t_1.q1(index).u4s_1;
  } else {
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0 = _this__u8e3s4.az().x11(index);
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList().w();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp0_safe_receiver = Companion_getInstance().q4r(element);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.v(tmp0_safe_receiver);
      }
    }
    tmp = destination;
  }
  return tmp;
}
var properties_initialized_VirtualType_kt_gu1823;
function _init_properties_VirtualType_kt__467cct() {
  if (!properties_initialized_VirtualType_kt_gu1823) {
    properties_initialized_VirtualType_kt_gu1823 = true;
    skipTypes = setOf(['com.lightningkite.lightningdb.Condition', 'com.lightningkite.lightningdb.Modification', 'com.lightningkite.lightningdb.DataClassPathPartial', 'com.lightningkite.lightningdb.SortPart']);
  }
}
//region block: init
Companion_instance_4 = new (Companion_4())();
Companion_instance_7 = new (Companion_7())();
Companion_instance_8 = new (Companion_8())();
Companion_instance_9 = new (Companion_9())();
Companion_instance_10 = new (Companion_10())();
Companion_instance_11 = new (Companion_11())();
Companion_instance_12 = new (Companion_12())();
Companion_instance_13 = new (Companion_13())();
Companion_instance_14 = new (Companion_14())();
Companion_instance_15 = new (Companion_15())();
Companion_instance_16 = new (Companion_16())();
//endregion
//region block: exports
export {
  ArrayValue as ArrayValue2pyfxqxwawdsa,
  ByteValue as ByteValue2mrn88qw6dczw,
  ClassValue as ClassValue2g3gvkd2w780o,
  IntValue as IntValue8ydihstvmcr7,
  StringValue as StringValue3u4w9lwhg0ah4,
  SerializableAnnotation as SerializableAnnotation2h7cqfq6xt1yy,
  VirtualEnumValue as VirtualEnumValue3slftlp5rcob7,
  Concrete as Concreteni4fg10vz3zt,
  getElementSerializableAnnotations as getElementSerializableAnnotations1zu2f30o6pbok,
  get_serializableAnnotations as get_serializableAnnotations9pir9fao2oo,
  Companion_getInstance as Companion_getInstance335jj07k1liay,
  Companion_getInstance_17 as Companion_getInstancendigucsaw94a,
  Companion_instance_7 as Companion_instance1uwi5qveups5a,
  Companion_instance_8 as Companion_instanceyg0acnb3y8ur,
  Companion_instance_14 as Companion_instance2xnezqm8k4iy6,
  Companion_instance_16 as Companion_instance1gz05lw05kmgt,
  Companion_getInstance_18 as Companion_getInstance3chrc9ba7w7cn,
  Companion_instance_13 as Companion_instances6uwm8m0c2sh,
  Companion_instance_12 as Companion_instance3k60yjsjepcqz,
  Companion_instance_10 as Companion_instance2hsf7r151zjoj,
  Companion_instance_11 as Companion_instance1z65nhbsy3ljt,
  NullValue_getInstance as NullValue_getInstance1rsbaonhpgnfm,
  Companion_instance_9 as Companion_instancenv8tmv5nw040,
  Companion_instance_15 as Companion_instance2o7nx4336u4bs,
  $serializer_getInstance_5 as $serializer_getInstance1bw8y9ehxjeca,
  Companion_getInstance_5 as Companion_getInstance22u7dztn23hkn,
  $serializer_getInstance_3 as $serializer_getInstance4ifn58chloth,
  Companion_getInstance_3 as Companion_getInstance1vhrrts3tgqok,
  Companion_getInstance_6 as Companion_getInstance28kbswf0q4ib,
  Companion_getInstance_0 as Companion_getInstance17duyot40gy2l,
  $serializer_getInstance_2 as $serializer_getInstance3lbn6ctli2gxh,
  Companion_getInstance_2 as Companion_getInstance3dkx52fv8xbgz,
  Companion_instance_4 as Companion_instance1m0a2cblw7mu,
  $serializer_getInstance_1 as $serializer_getInstancebqw0kelmheg1,
  Companion_getInstance_1 as Companion_getInstance40jjb0q1rrt7,
};
//endregion

//# sourceMappingURL=VirtualType.mjs.map
